__turbopack_context__.v({
  "content": "ky4AfG_content",
  "disclaimer": "ky4AfG_disclaimer",
  "optimizationContent": "ky4AfG_optimizationContent",
  "optimizationElement": "ky4AfG_optimizationElement",
  "placeholder": "ky4AfG_placeholder",
  "root": "ky4AfG_root" + " " + __turbopack_context__.i(768839)["sectionPadding"],
});
